<template>
  <div class="form-base">
    <v-row>
      <v-col cols="12">
        <DadataOrgField
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Наименование, указанное в ЕГРЮЛ"
          outlined
          :suggestions="suggestions"
          field="name"          
          @suggest="onSelect"           
        />
      </v-col>
    </v-row>

    <v-radio-group class="mt-0" v-model="v.hasOgrn.$model">
      <v-radio label="ОГРН" :value="true" />
      <v-radio label="ИНН" :value="false" />
    </v-radio-group>
    <v-row>
      <v-col cols="12">
        <DadataOrgField
          v-if="v.hasOgrn.$model"
          v-model="v.ogrn.$model"
          mask="#############"
          :key="'ogrn'"
          :errorMessages="getValidationErrorText(v.ogrn)"
          label="ОГРН"
          outlined
          :suggestions="suggestions"
          field="ogrn"          
          @suggest="onSelect"           
        />
        <DadataOrgField
          v-if="!v.hasOgrn.$model"
          v-model="v.inn.$model"
          mask="##########"
          :key="'inn'"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          outlined
          :suggestions="suggestions"
          field="inn"          
          @suggest="onSelect"           
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  maxLength,
  minLength,
  required,
  requiredIf,
} from 'vuelidate/lib/validators';

import {
  getValidationErrorText,
  EMOJI,
  EMAIL,
  MAX_LENGTH_EMAIL,
} from '@/utils/validate';
import DadataOrgField from '@/components/base/DadataOrgField';

export const organizationModel = {
  hasOgrn: true,
  name: '',
  ogrn: '',
  inn: '',
  email: '',
};

export const organizationValidation = {
  hasOgrn: {},
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  ogrn: {
    required: requiredIf((vm) => vm.hasOgrn),
    minLength: minLength(13),
  },
  inn: {
    required: requiredIf((vm) => !vm.hasOgrn),
    minLength: minLength(10),
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
};

export default {
  name: 'Organization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    DadataOrgField,    
  },
  data: () => ({
    suggestions: [],
    getValidationErrorText,
  }),
  methods: {
    onSelect: function (item) {
      this.suggestions = [item];
      this.v.name.$model = item.name;
      this.v.inn.$model = item.inn;
      this.v.ogrn.$model = item.ogrn;
      this.v.email.$model = item.email;
    }
  },    
};
</script>
